<template>
    <div>
        <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
            <template slot="filters">
                <el-form-item label="设备类型" prop="deviceType">
                    <DeviceType v-model="deviceType" />
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="query.phone" placeholder="请输入手机号" clearable />
                </el-form-item>
            </template>
            <template slot="columns">
                <el-table-column label="终端类型" align="center" prop="productType"></el-table-column>
                <el-table-column label="类型" align="center" prop="category"></el-table-column>
                <el-table-column label="产品类型" align="center" prop="deviceType"></el-table-column>
                <el-table-column label="设备名称" align="center" prop="deviceName"></el-table-column>
                <el-table-column label="关联手机号" align="center" prop="phone"></el-table-column>
                <el-table-column label="关联邮箱" align="center" prop="email"></el-table-column>
                <el-table-column label="操作" align="center" width="140">
                    <template slot-scope="{ row }">
                        <el-link v-if="permission('/device/notice/bind') && !row.phone && !row.email" :underline="false" type="primary" @click="handleBind(row)">
                            绑定
                        </el-link>
                        <el-link v-if="permission('/device/notice/edit') && (row.phone || row.email)" :underline="false" type="primary" @click="handleBind(row)">
                            编辑
                        </el-link>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <el-dialog width="500px" title="绑定手机和邮箱" :visible.sync="visible">
            <el-form :model="form" ref="form" :rules="rules" label-width="80px">
                <el-form-item label="终端类型" prop="productType">
                    <el-input disabled v-model="form.productType"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="category">
                    <el-input disabled v-model="form.category"></el-input>
                </el-form-item>
                <el-form-item label="产品类型" prop="deviceType">
                    <el-input disabled v-model="form.deviceType"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input disabled v-model="form.deviceName"></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getDeviceBaseInfoList, editDeviceBaseInfo } from "@/api/device/list";
import listMixin from '@/mixins/list';
import DeviceType from "@/components/DeviceType.vue";
export default {
    components: { DeviceType },
    data() {
        return {
            // 查询参数
            query: {
                deviceType: "",
                productType: "",
                phone: ""
            },
            visible: false,
            form: {
                productType: "",
                category: "",
                deviceType: "",
                deviceName: "",
                phone: "",
                email: ""
            },
            deviceType: [],
            rules: {
                phone: [{ pattern: /^1[3456789]\d{9}$/, message: "手机号格式不正确", trigger: "blur" }],
                email: [{ pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: "邮箱格式不正确", trigger: "blur" }]
            }
        };
    },
    watch: {
        deviceType(val) {
            if (val.length) {
                this.query.productType = val[0];
                this.query.deviceType = val[1];
            } else {
                this.query.productType = '';
                this.query.deviceType = '';
            }
        }
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            getDeviceBaseInfoList(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleBind(row) {
            this.visible = true;
            this.form = { ...row };
        },
        handleConfirm() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                editDeviceBaseInfo({ ...this.form }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success("操作成功");
                        this.visible = false;
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            })
        },
        resetQuery() {
            this.deviceType = [];
            this.query = {
                deviceType: "",
                productType: "",
                phone: ""
            }
            this.handleSearch();
        }
    },
};
</script>